
import useReports from "./hook/useReports";
import TableHeadings from '../../components/Common-components/table-headings'
import useLanguage from "../../hooks/useLanguage";
import { imageBaseUrl } from "../../components/Constant";
import { Spinner } from '../../components/Common-components/spinner';
import { getLocalizedText } from "../../utils";
import TableContainer from "./component/tableContainer";
import { Avatar } from "@mui/material";
import moment from "moment-timezone";
const Completed = () => {
    const { isEngLang, t } = useLanguage();
    const {
        completedTableHead,
        details,
        loader,
        totalCount,
        controller,
        handlePagination,
    } = useReports();
    return (
        <>
            {loader && <Spinner />}
            <TableContainer handlePagination={handlePagination} data={details} totalCount={totalCount} title={`${t("boxTitle.completed")}`} controller={controller}>
                <table className="table ">
                    <TableHeadings removeTr={true} TableHeadData={completedTableHead} />
                    <tbody>
                        {details?.map((cur, index) => (
                            <>
                                <tr className='fw-4 font-12' key={cur?._id} >
                                    <td className="">
                                        <Avatar alt={cur?.clientName} src={`${imageBaseUrl}profile/thumbnail/${cur?.clientImage}`} />
                                    </td>
                                    <td>{cur?.bookingReferenceNumber}</td>
                                    <td>{cur?.clientName ?? "-"}</td>
                                    <td>{cur?.serviceName ?? "-"}</td>
                                    <td>{cur?.quantity ?? "-"}</td>
                                    <td>{cur?.finalPrice ?? "-"}</td>
                                </tr>
                                <tr className='default_tr_gap'> </tr>
                            </>
                        ))}
                    </tbody>
                </table>
            </TableContainer>
        </>

    )
}

export default Completed
